import Request from '../../../../src/core/gd/data/request'
import {ProjectAccess} from "../const/project";
import UserToAdd from "../../gd-modals/users/model/add-user";

export default class ApiProjectUser {

    constructor() {
    }


    updateAccess(projectId:ID, userId:ID, newAccess:ProjectAccess) {
        return new Request(this, 'PUT', 'project/'+projectId+'/users/'+userId+'/access', {
            access: newAccess
        });
    }


    updateWatchAll(projectId:ID, userId:ID, newValue:boolean) {
        return new Request(this, 'PUT', 'project/'+projectId+'/users/'+userId+'/watch-all', {
            watchAll: newValue
        });
    }

    add(projectId:ID, userId:ID, projectAccess:ProjectAccess, projectRole:any, watchAll:boolean) {
        return new Request(this, 'POST', 'project/'+projectId+'/users', {
            userId: userId,
            role: projectRole,
            access: projectAccess,
            watchAll: watchAll
        });
    }

    static createProjectUsers(projectId: ID, usersToCreate:UserToAdd[]) {

        const payload = _.map(usersToCreate, (userToAdd) => {
            return {
                access      : userToAdd.projectAccess,
                userId      : userToAdd.user.id,
                // type        : "company"
            }
        })

        return new Request(this, 'POST', 'project/'+projectId+'/users-add-many', {
            users: payload
        });

    }

    static createWorkspaceUsers(projectId: ID, usersToCreate:UserToAdd[]) {

        const payload = _.map(usersToCreate, (userToAdd) => {
            return {
                access      : userToAdd.workspaceAccess,
                userId      : userToAdd.user.id,
                // type        : "company"
            }
        })

        return new Request(this, 'POST', 'project/'+projectId+'/users-add-many', {
            users: payload
        });

    }


}

